import React, { useState, useEffect } from "react";
// utils
import FormButton from "../../button/FormButton";
// functions
import { postFormato, deleteFormato, updateFormato } from './FormatosXTipoDeImagenFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './FormatosXTipoDeImagenFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState';
import CommonForm from "../CommonForm";
import { FormikTextInput } from "../../inputs/FormikInputs";

export default function FormatosXTipoDeImagenForm(props) {
    const [newFormato, setNewFormato] = useState({});

    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteFormato(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Formato por tipo de imagen eliminado exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postFormato(credentials, newFormato, setInRequest)
            return handleResponse(response, 'Formato por tipo de imagen añadido exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateFormato(credentials, newFormato, selected.row, setInRequest)
            return handleResponse(response, 'Formato por tipo de imagen modificado exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newFormato])

    const formik = formikValidation(setNewFormato, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name='nombre'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='codigo'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='ancho'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='alto'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='bucket'
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name='folder'
                formik={formik}
                disabled={disabled}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm >
    );
};